import { render, staticRenderFns } from "./LicensePropertiesWidget.vue?vue&type=template&id=0abe157b&lang=pug"
import script from "./LicensePropertiesWidget.vue?vue&type=script&lang=js"
export * from "./LicensePropertiesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports